import { Box } from "@chakra-ui/react";
import { useState } from "react";

//import components
import Navbar from "../Navbar/Navbar";
import SimpleSlider from "../Slider";
import Sidebar from "../sidebar/sidebar";
import Footer from "../footer/footer";

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <SimpleSlider isMenuOpen={isMenuOpen} />
      <Box
        marginTop={10}
        marginX="auto"
        width={{ base: "97%", md: "93.7%", xl: "93.7%" }}
      >
        <Sidebar />
      </Box>
      <Footer />
    </>
  );
}
